// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"keB82y","image":"g1kfjf","text":"dBiDLk"};